"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const palette_1 = require("../palette");
const muiDialog = {
    styleOverrides: {
        paper: {
            backgroundColor: palette_1.palette.grey[200],
        },
    },
};
exports.default = muiDialog;
//# sourceMappingURL=muiDialog.js.map